import { render, staticRenderFns } from "./ZhengCeFaGui.vue?vue&type=template&id=6acc9562&scoped=true&"
import script from "./ZhengCeFaGui.vue?vue&type=script&lang=js&"
export * from "./ZhengCeFaGui.vue?vue&type=script&lang=js&"
import style0 from "./ZhengCeFaGui.vue?vue&type=style&index=0&id=6acc9562&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acc9562",
  null
  
)

export default component.exports